/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Public_Faq_HeadingInputs */

const en_pricing_public_faq_heading = /** @type {(inputs: Pricing_Public_Faq_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crazy Frog AI pricing FAQ`)
};

const es_pricing_public_faq_heading = /** @type {(inputs: Pricing_Public_Faq_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preguntas frecuentes sobre precios de Crazy Frog AI`)
};

/**
* | output |
* | --- |
* | "Crazy Frog AI pricing FAQ" |
*
* @param {Pricing_Public_Faq_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pricing_public_faq_heading = /** @type {((inputs?: Pricing_Public_Faq_HeadingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Public_Faq_HeadingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricing_public_faq_heading(inputs)
	return es_pricing_public_faq_heading(inputs)
});